import { postSelectMarketRankByCon } from "../../../request/orderActivityApi/selectMarketRankByCon/post.js";
async function getUnifySelectInventoryMarketRank({
  options,
  orgNo,
  getMarketRankByCon
}) {
  const { marketClassify } = options || {};
  if (marketClassify) {
    const innerGetMarketRankByCon = getMarketRankByCon || postSelectMarketRankByCon;
    const data = await innerGetMarketRankByCon({
      marketClassify,
      orgNo
    });
    return data;
  }
  return null;
}
export { getUnifySelectInventoryMarketRank };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/business/unifySelectInventory/activity/getMarketRank.js